@if (!loading && data.length) {
  <rt-data-table
    [raised]="false"
    [autoFit]="true"
    [selectable]="editable"
    [clickable]="editable"
    [selectedIdsDict]="selectedIdsDict"
    [cols]="columns"
    [rows]="data"
    [cellTemplates]="templates"
    [cellPadding]="false"
    (sortChange)="sortChange.emit($event)"
    (rowClick)="editable && !isEdited($event.id) ? rowSelect.emit($event.id) : null"
    (rowSelect)="rowSelect.emit($event.row.id)"
  ></rt-data-table>
}

@if (loading) {
  <rt-data-table
    [cols]="columns"
    [rows]="placeloaderRows"
    [defaultCellTemplate]="placeloaderCell"
  ></rt-data-table>

  <ng-template #placeloaderCell let-columnId="columnId" [ngTemplateType]="CellContext">
    <rt-placeloader
      [style.height]="'20px'"
      [style.maxWidth]="
        columnId !== DepartmentsColumnId.Value ? getRandomWidth(40, 70) : getRandomWidth()
      "
      variant="item"
    >
    </rt-placeloader>
  </ng-template>
}

<ng-template #valueTemplate let-attr="row" [ngTemplateType]="CellContext">
  <ng-container
    *ngTemplateOutlet="editable && isEdited(attr.id) ? attrEdit : attrIdle"
  ></ng-container>

  <ng-template #attrEdit>
    <div class="attr-name attr-name--editing" margin-right-small>
      <rt-input variant="rounded" [formControl]="valueControl" [autoFocus]="true"></rt-input>
      <rt-group variant="horizontal">
        <rt-button
          variant="primary"
          [loading]="isSaved(attr.id)"
          [disabled]="valueControl.invalid || valueControl.pristine"
          (click)="save.emit({ value: valueControl.value, id: attr.id }); $event.stopPropagation()"
        >
          {{ 'app.common.save' | translate }}
        </rt-button>
        <rt-button
          [disabled]="isSaved(attr.id)"
          variant="plain"
          (click)="edit.emit($any(attr.id)); $event.stopPropagation()"
        >
          {{ 'app.common.cancel' | translate }}
        </rt-button>
      </rt-group>
    </div>
  </ng-template>

  <ng-template #attrIdle>
    <div
      class="attr-name attr-name--idle"
      [attr.margin-left-small]="!editable ? '' : null"
      margin-right-small
    >
      <div>
        <span>{{ attr.value }}</span>
      </div>
      @if (translationsProgressMap) {
        <rt-circular-progress-indicator
          [rtTooltip]="getLangTooltip(attr.id)"
          [percent]="translationsProgressMap[attr.id].percent"
          margin-right-small-xx
        >
        </rt-circular-progress-indicator>
      }
      @if (editable) {
        <rt-icon-button (click)="edit.emit(attr)" variant="plain" iconName="edit" shape="square">
        </rt-icon-button>
      }
    </div>
  </ng-template>
</ng-template>

<ng-template #countTemplate let-attr="row" [ngTemplateType]="CellContext">
  <div (click)="$event.stopPropagation()" padding-lr-small-x padding-tb-small>
    <span>{{ attr.count }}</span>
  </div>
</ng-template>

<ng-template #jobsCountTemplate let-attr="row" [ngTemplateType]="CellContext">
  <div (click)="$event.stopPropagation()" padding-lr-small-x padding-tb-small>
    <span>{{ attr.jobsCount }}</span>
  </div>
</ng-template>

<ng-template #talentPoolsCountTemplate let-attr="row" [ngTemplateType]="CellContext">
  <div (click)="$event.stopPropagation()" padding-lr-small-x padding-tb-small>
    <span>{{ attr.talentPoolsCount }}</span>
  </div>
</ng-template>
